export default __webpack_public_path__ + "static/thedapplist-6017640f899fa719145cc66cf5f889ef.jpg";